import { Grid, MenuItem } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import {
  getContractTypes,
  getDegreeLevels,
  getOffresEntreprise,
  getOffresMap,
} from '@webapps/business';
import {
  Button,
  Pagination,
  PaginationNumbers,
  TextField,
  useAuth,
  useQuery,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Modal from 'components/Modal';
import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

import CardFormation from './CardFormation';
import CreateAnnonce from './CreateAnnonce';

const Annonces = ({ handleAnnonceLength, idBusinessExternal, toRefetch, setToRefetch }) => {
  const {
    classes,
    global,
    cx,
    css,
    theme: { spacing },
  } = useStyles(styles);
  const intl = useIntl();
  const { idUser } = useAuth();
  const location = useLocation();
  const [contractType, setContractType] = useState('');
  const [degreeLevel, setDegreeLevels] = useState('');
  const [openCreateAnnonce, setOpenCreateAnnonce] = useState(false);
  const [keyword, setKeyword] = useState('');

  const itemCount = 12;

  const handleOpenCreateAnnonce = () => {
    setOpenCreateAnnonce(true);
  };

  const handleCloseCreateAnnonce = () => {
    setOpenCreateAnnonce(false);
  };

  const [page, setPage] = useState(1);
  const [stepModal, setStepModal] = useState(1);

  useEffect(() => {
    if (location.state?.openCreateAnnonce) {
      handleOpenCreateAnnonce();
      location.state.openCreateAnnonce = false;
    }
  }, [location]);

  const {
    status: load,
    data: { content: offres = [], totalElements } = {},
    refetch,
    //isFetching,
  } = useQuery(getOffresMap, {
    key: ['offres', page + idUser + keyword + contractType + degreeLevel],
    variables: {
      keyword,
      [idBusinessExternal ? 'businessesExternals' : 'businesses']: idBusinessExternal || idUser,
      contracts: contractType,
      degreeLevels: degreeLevel,
      page: page - 1,
      size: itemCount,
      status: 'all',
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  useEffect(() => {
    if (toRefetch) {
      refetch();
      setToRefetch(false);
    }
  }, [toRefetch]);

  const { data: contractTypes = [] } = useQuery(getContractTypes, {
    key: 'contractTypes',
  });

  const { data: degreeLevels = [] } = useQuery(getDegreeLevels, {
    key: 'levels',
  });
  const searchDegreeLevels = (e) => {
    if (e.target.value) {
      // eslint-disable-next-line no-unused-expressions
      e.target.value === 'all'
        ? setDegreeLevels('')
        : setDegreeLevels(e.target.value);
      setPage(1);
    }
  };

  const searchContract = (e) => {
    if (e.target.value) {
      // eslint-disable-next-line no-unused-expressions
      e.target.value === 'all'
        ? setContractType('')
        : setContractType(e.target.value);
      setPage(1);
    }
  };

  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };

  const searchAnnonce = (e) => {
    // if (e.target.value) {
    setKeyword(e.target.value);
    setPage(1);
    // }
  };

  // CHECK PREMIUM / FREE SUBSCRIPTION
  const { isPremium } = useAuth();

  // RETRIEVE OFFERS WITH OPEN STATUS
  const { data: { content: openOffers = [] } = {}, isFetching } = useQuery(
    getOffresEntreprise,
    {
      key: ['offres', page],
      variables: {
        id: typeof idParam !== 'undefined' ? idParam : idUser,
        page: page - 1,
        size: 3,
        status: 'opened',
      },
      keepPreviousData: true,
      staleTime: 5000,
    }
  );

  useEffect(() => {
    handleAnnonceLength(totalElements);
  }, [totalElements]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: 20,
        height: '100%',
      }}
    >
      <div
        className={css({
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: spacing(1),
          '@media (max-width: 768px)': {
            flexDirection: 'column',
          },
        })}
      >
        <TextField
          label={intl.formatMessage({
            id: 'business.annoncesCandidats.searchAnnonce',
          })}
          onChange={(e) => searchAnnonce(e)}
          variant="outlined"
          borderRadius={30}
        />
        <div className={classes.selectInput} >
          <TextField
            fullWidth
            label="Type de contrat"
            name="offer"
            onChange={(e) => searchContract(e)}
            variant="outlined"
            select
            borderRadius={30}
          >
            <MenuItem value="all">Tous les contrats</MenuItem>
            {contractTypes.map(({ id, label }, index) => (
              <MenuItem key={index} value={id}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        </div>
        <div className={classes.selectInput}>
          <TextField
            fullWidth
            label="Niveau d'étude"
            name="degreeLevels"
            onChange={(e) => searchDegreeLevels(e)}
            variant="outlined"
            borderRadius={30}
            select
          >
            <MenuItem value="all">Tous les niveaux</MenuItem>
            {degreeLevels.map(({ id, label }, index) => (
              <MenuItem key={index} value={id}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        </div>

        {((!isFetching && !isPremium && openOffers.length < 1) || isPremium) &&
          !idBusinessExternal && (
            <div
              className={css({
                display: totalElements > 0 ? 'flex' : 'none',
              })}
            >
              <Button
                color="primary"
                onClick={handleOpenCreateAnnonce}
                variant="contained"
                className={classes.btn}
                disableElevation={true}
                style={{
                  fontWeight: 600,
                }}
              >
                <FormattedMessage id="business.annoncesCandidats.btnPublierAnnonce" />
              </Button>

              <Modal
                nbStep={5}
                onCancel={handleCloseCreateAnnonce}
                open={openCreateAnnonce}
                step={stepModal}
                title={intl.formatMessage({
                  id: 'business.annoncesCandidats.publierAnnonceSubTitle',
                })}
              >
                <CreateAnnonce
                  onChangeStepModal={setStepModal}
                  onClose={handleCloseCreateAnnonce}
                  refetchOffre={refetch}
                />
              </Modal>
            </div>
          )}
      </div>

      <div className={classes.annonces}>
        <Grid
          className={css({
            // maxHeight: itemCount < totalElements ? 'calc(100vh - 75px - 243px)' : 'calc(100vh - 75px - 193px)',
            '@media screen and (max-width: 1023px)': {
              // maxHeight: '100%',
            },
            overflow: 'auto',
            height: '100%',
          })}
        >
          {!offres?.length ? (
            <Grid
              container
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Grid
                item
                xs={12}
                className={css({
                  display: 'flex',
                  height: '100%',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: '#F3F7FF',
                  borderRadius: 12,
                  minHeight: 'calc(100vh - 75px - 193px)',
                  '@media only screen and (max-width:1023px)': {
                    minHeight: 'calc(100vh - 75px - 293px)',
                  },
                  '@media screen and (max-width: 768px)': {
                    padding: '20px',
                  },
                })}
              >
                <Grid
                  item
                  className={css({
                    backgroundColor: '#FFFFFF',
                    borderRadius: 12,
                    padding: '30.0px',
                    '@media screen and (max-width: 768px)': {
                      padding: '20px',
                    },
                  })}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <h1 className={cx(classes.title, global.title)}>
                      {' '}
                      Commencez à publier vos offres d'emploi.
                    </h1>
                    <p className={cx(classes.text, global.infoText)}>
                      {' '}
                      {idBusinessExternal ? "1 . Déposez une offre d'emploi exclusives pour vos apprenants" : "1 . Recherchez un partenariat avec un établissement de formation."}
                    </p>
                    <p className={cx(classes.text, global.infoText)}>
                      {' '}
                      {idBusinessExternal ? "2 . Retrouvez les ici, dans votre vitrine ou dans la recherche d'offres" : "2 . Décidez de les ajouter aux prospects avant d'envoyer une demande."}
                    </p>
                    <p className={cx(classes.text, global.infoText)}>
                      {' '}
                      {idBusinessExternal ? "3 . Recevez les candidatures sur le mail de votre compte." : "3 . Sourcez dans l'établissement des profils qualifiés depuis la CVthèque."}
                    </p>
                    {!idBusinessExternal && (
                      <Button
                        color="primary"
                        onClick={handleOpenCreateAnnonce}
                        variant="contained"
                        className={css({
                          marginTop: 20,
                        })}
                      >
                        Publier une offre
                      </Button>
                    )}
                  </div>
                </Grid>
              </Grid>
            </Grid>
          ) : (
            <Grid
              container
              className={css({
                backgroundColor: '#F3F7FF',
                borderRadius: 10,
                padding: spacing(2.5, 0, 0, 2.5),
              })}
            >
              {offres?.map((item, index) => (
                <CardFormation
                  key={index}
                  address={item?.address}
                  contrat={item?.contractType}
                  createdAt={item?.createdAt}
                  idBusinessExternal={idBusinessExternal}
                  item={item}
                  name={item?.job}
                  refetch={refetch}
                  typeFormation={item?.degreeLevel}
                />
              ))}
            </Grid>
          )}
        </Grid>
      </div>

      <PaginationNumbers
        onChange={handlePaginationChange}
        noMargin={true}
        page={page}
        pageCount={itemCount}
        totalCount={totalElements}
      />
    </div>
  );
};

const styles = ({ spacing }) => ({
  annonces: { flex: 1 },
  title: {
    textAlign: 'center',
    margin: '0px 0px 30px 0px',
  },
  text: {
    textAlign: 'center',
    margin: '5px',
  },
  btn: {
    width: '100%',
  },
  selectInput: {
    width: '200px',
  }
});

export default Annonces;
